'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StatusBannerMessage = require('./StatusBannerMessage.scss');

var _StatusBannerMessage2 = _interopRequireDefault(_StatusBannerMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatusBannerMessage = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(StatusBannerMessage, _Component);

    function StatusBannerMessage() {
        (0, _classCallCheck3.default)(this, StatusBannerMessage);
        return (0, _possibleConstructorReturn3.default)(this, (StatusBannerMessage.__proto__ || (0, _getPrototypeOf2.default)(StatusBannerMessage)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatusBannerMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['alert', 'header', 'iconName', 'message']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                alert = _props.alert,
                header = _props.header,
                iconName = _props.iconName,
                message = _props.message;

            var iconClasses = alert ? _StatusBannerMessage2.default.icon + ' ' + _StatusBannerMessage2.default.alert : _StatusBannerMessage2.default.icon;
            var messageClasses = alert ? _StatusBannerMessage2.default.message + ' ' + _StatusBannerMessage2.default.alert : _StatusBannerMessage2.default.message;

            return (0, _jsx3.default)('div', {
                className: _StatusBannerMessage2.default['status-banner-message']
            }, void 0, (0, _jsx3.default)(_reactFontawesome2.default, {
                icon: iconName,
                className: iconClasses
            }), (0, _jsx3.default)('div', {
                className: messageClasses
            }, void 0, (0, _jsx3.default)('span', {
                className: _StatusBannerMessage2.default.header
            }, void 0, header), (0, _jsx3.default)('span', {
                className: _StatusBannerMessage2.default.body
            }, void 0, message)));
        }
    }]);
    return StatusBannerMessage;
}(_react.Component), _class.defaultProps = {
    alert: false,
    message: ''
}, _temp);
exports.default = StatusBannerMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/StatusBanner/StatusBannerMessage.js
// module id = m1mj
// module chunks = 57